import { render, staticRenderFns } from "./LatestFacilities.vue?vue&type=template&id=aeb9e4e6&scoped=true&"
import script from "./LatestFacilities.vue?vue&type=script&lang=js&"
export * from "./LatestFacilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb9e4e6",
  null
  
)

export default component.exports